import React, { ReactNode } from 'react';
import classNames from 'classnames';

interface Props {
	label: ReactNode;
	value?: ReactNode;
	tone?: 'on' | 'off' | 'warn';
	mono?: boolean;
	note?: ReactNode;
}

export default function Chip({
	label, value, tone, mono = false, note,
}: Props) {
	return (
		<span className={classNames('health-chip', {
			'health-chip--mono': mono,
			[`health-chip--${tone}`]: !!tone,
		})}
		>
			{label}
			{value !== undefined && <span className='health-chip__value'>{value}</span>}
			{note !== undefined && <span className='health-chip__note'>{note}</span>}
		</span>
	);
}
